export default theme => ({
  status: {
    borderRadius: 5,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 9,
    paddingRight: 9,
    fontSize: 12,
    fontWeight: 500,
    color: 'white',
    '&.running': {
      backgroundColor: theme.palette.info.main
    },
    '&.success': {
      backgroundColor: theme.palette.success.main
    },
    '&.failure': {
      backgroundColor: theme.palette.error.main
    }
  },
  overflow: {
    width: 0,
    '&.popper': {
      width: 'auto'
    }
  },
  scheduledDate: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 'normal',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    '& .MuiSvgIcon-root': {
      width: 20,
      height: 20,
      marginRight: theme.spacing(1),
      color: theme.palette.text.secondary
    }
  },
  synchronizablesChipsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    lineHeight: 'normal'
  },
  synchronizables: {
    display: 'flex',
    flexWrap: 'wrap',
    lineHeight: 'normal',
    height: 24,
    '&.popper': {
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      '& > div:not(:last-child)': {
        marginBottom: theme.spacing(1)
      }
    }
  },
  synchronizablesChipsColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > div:not(:last-child)': {
      marginBottom: theme.spacing(1)
    }
  },
  errorMessage: {
    margin: 0,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    fontSize: 12,
    maxWidth: 800,
    maxHeight: 500,
    overflow: 'auto',
    backgroundColor: theme.palette.action.hover,
    borderRadius: 3
  },
  confirmationSynchronizables: {
    '& > *': {
      marginTop: theme.spacing(0.5)
    }
  }
});
